import { propClassName } from '@/styles/TextField';
import { ClassNameProp, ComponentProps, ComponentWithRef } from '@/types/component';
import { cn } from 'lib/utils/cn';
import React from 'react';

export interface TextFieldInputProps extends Omit<ComponentProps<'input'>, 'size'> {
  colors?: ClassNameProp<'primary'>;
  size?: ClassNameProp<'default' | 'alternative'>;
  variant?: ClassNameProp<'default' | 'alternative'>;
}

export const TextFieldInputComponent: ComponentWithRef<HTMLInputElement, TextFieldInputProps> = React.forwardRef(
  ({ className, colors, size, variant, ...props }, ref) => {
    const sizeClassName = propClassName('input_size', size ?? variant, 'default');
    const colorsClassName = propClassName('input_colors', colors, 'primary');
    const variantClassName = propClassName('input_variant', variant, 'default');
    const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

    return <input className={componentClassName} {...{ ref }} {...props} />;
  }
);
